<script lang="ts">
  import PageSection from '@athena-lib/Page/PageSection.svelte';
  import { storyblokEditable } from '@storyblok/svelte';
  import type { BlogPostInfoBlock } from '@storyblok-types';
  import { pageSectionYSpaceCaster } from '@athena-lib/Page/types';
  import Image from '@athena-lib/Image/Image.svelte';
  import { getCommonTranslations } from '@athena-lib/commonTranslationsContext';
  import { getBlogPostContext } from './BlogPostBlok.svelte';

  const { blok }: { blok: BlogPostInfoBlock } = $props();
  const blogPostContext = getBlogPostContext();
  const blogBlok = $derived(blogPostContext?.value);

  const author = $derived(blogBlok?.author);
  const translations = getCommonTranslations();
</script>

<PageSection
  action={storyblokEditable}
  actionArg={blok}
  ySpace={{
    top: pageSectionYSpaceCaster(blok.paddingTop) ?? 'medium',
    bottom: pageSectionYSpaceCaster(blok.paddingBottom) ?? 'medium',
  }}
>
  <hr class="mb-8 border-2 border-st-gray-800" />
  <div class="flex items-center justify-between">
    {#if author}
      <div class="flex gap-3">
        <div>
          {#if author.imageUrl}
            <Image
              imgClass="h-16 w-16 aspect-square rounded-full object-cover"
              src={author.imageUrl}
              alt={author.imageAlt ?? ''}
            />
          {/if}
        </div>
        <div class="flex flex-col justify-center gap-0">
          <div class="text-st-gray-600">{translations.author}</div>
          <a href={author.pageUrl} class="font-bold">{author.name}</a>
        </div>
      </div>
    {/if}
  </div>
</PageSection>
